import axiosClient from "./axiosClient";

export async function fetchAddresses() {
  const response = await axiosClient.get("/Addresses");
  return response.data;
}

export async function addAddress(payload) {
  const response = await axiosClient.post("/Addresses", payload);
  return response.data;
}

export async function updateAddress(addressId, payload) {
  const response = await axiosClient.put(`/Addresses/${addressId}`, payload);
  return response.data;
}

export async function removeAddress(addressId) {
  await axiosClient.delete(`/Addresses/${addressId}`);
}

export async function setDefaultAddress(addressId) {
  await axiosClient.put(`/Addresses/${addressId}/default`, {});
}
